"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Season model module.
 * @module model/Season
 * @version 1.1.3-alpha.1
 */
class Season {
  /**
   * Constructs a new <code>Season</code>.
   * @alias module:model/Season
   */
  constructor() {
    Season.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>Season</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Season} obj Optional instance to populate.
   * @return {module:model/Season} The populated <code>Season</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Season();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('season_parent_id')) {
        obj['season_parent_id'] = _ApiClient.default.convertToType(data['season_parent_id'], 'String');
      }
      if (data.hasOwnProperty('season_number')) {
        obj['season_number'] = _ApiClient.default.convertToType(data['season_number'], 'Number');
      }
      if (data.hasOwnProperty('season_caption')) {
        obj['season_caption'] = _ApiClient.default.convertToType(data['season_caption'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Season</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Season</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['season_parent_id'] && !(typeof data['season_parent_id'] === 'string' || data['season_parent_id'] instanceof String)) {
      throw new Error("Expected the field `season_parent_id` to be a primitive type in the JSON string but got " + data['season_parent_id']);
    }
    // ensure the json data is a string
    if (data['season_caption'] && !(typeof data['season_caption'] === 'string' || data['season_caption'] instanceof String)) {
      throw new Error("Expected the field `season_caption` to be a primitive type in the JSON string but got " + data['season_caption']);
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
Season.prototype['id'] = undefined;

/**
 * @member {String} season_parent_id
 */
Season.prototype['season_parent_id'] = undefined;

/**
 * @member {Number} season_number
 */
Season.prototype['season_number'] = undefined;

/**
 * @member {String} season_caption
 */
Season.prototype['season_caption'] = undefined;

/**
 * @member {String} title
 */
Season.prototype['title'] = undefined;
var _default = Season;
exports.default = _default;